import { apiFetch } from "../lib/request";

export async function loadSubscription(uid) {
  if (!uid) throw new Error("Missing uid");
  return apiFetch("/users/subscriptions", {
    method: "POST",
    body: JSON.stringify({ uid }),
  });
}

export async function createCheckoutSession({ uid, priceId, planId, projectId, successUrl, cancelUrl, couponCode }) {
  if (!uid || !priceId || !successUrl || !cancelUrl || !projectId) {
    throw new Error("Missing required checkout session parameters");
  }

  return apiFetch("/subscriptions/create-checkout-session", {
    method: "POST",
    body: JSON.stringify({ uid, priceId, planId, projectId, successUrl, cancelUrl, couponCode }),
  });
}

export async function loadPlans() {
  return apiFetch("/plans", { method: "GET" });
}

export async function provisionFreePlan({ planId, projectId }) {
  if (!planId || !projectId) {
    throw new Error("Missing required free plan parameters");
  }

  return apiFetch("/subscriptions/provision-free", {
    method: "POST",
    body: JSON.stringify({ planId, projectId }),
  });
}

export async function requestDomainVerification({ projectId }) {
  if (!projectId) throw new Error("Missing required project");

  return apiFetch("/subscriptions/domain-verification/request", {
    method: "POST",
    body: JSON.stringify({ projectId }),
  });
}

export async function confirmDomainVerification({ projectId, code }) {
  if (!projectId || !code) throw new Error("Missing required verification parameters");

  return apiFetch("/subscriptions/domain-verification/confirm", {
    method: "POST",
    body: JSON.stringify({ projectId, code }),
  });
}
export async function getSubscription(uid) {
  if (!uid) throw new Error("Missing uid");
  return apiFetch(`/subscriptions/${encodeURIComponent(uid)}`, { method: "GET" });
}

export async function createPortalSession({ uid, returnUrl, projectId }) {
  if (!uid || !returnUrl) {
    throw new Error("Missing required portal session parameters");
  }

  return apiFetch("/subscriptions/create-portal-session", {
    method: "POST",
    body: JSON.stringify({ uid, returnUrl, projectId }),
  });
}
